import { useContext } from 'react';

import { AuthContext } from '../context/jwt/auth-context';

// ----------------------------------------------------------------------

export const useAuthContext = () => {
  const context = useContext(AuthContext);

   // ตรวจสอบ context
   if (!context) {
    console.error('AuthContext ไม่มีค่า ตรวจสอบการกำหนด AuthProvider');
    return {
      user: null,
      loading: true,
      authenticated: false,
    };
  }

  return context;
};
